

(function (App, Router, Controller, Service, Handler, Helper, Config, Model, $, Hotjar) {
  'use strict';

  // ==================================================
  // Ejecicion inicial
  // ==================================================  	
  App.init = function () {
    Service.startComscore();
    Service.startEstadisticas();
    Service.createCustomDimension();
    Service.startGoogleTagManager();
    Service.startGoogleOptimize();
    Service.startHotjar();
    Service.setup();

    if (Helper.readCookie('usuario%5Fid')) {
      Hotjar.startRecording(['userId', Helper.readCookie('usuario%5Fid')]);
    } else {
      Hotjar.startRecording(['userId', 'SinSesion']);
    }
  }

  App.reload = function () {
    Helper.resetAll(function () {
      App.init();
    });
  }

  // ==================================================
  // Step Handler Event
  // ==================================================  

  //$(document.body).on('submit', 'form', function (e) {
  //    e.preventDefault();
  //    //var step = $('.next-step').data('step');              
  //    //Handler.stepHandler(step);
  //});



  //});

  $(document.body).on('keypress', document.body, function (e) {
    if (e.which === 13) {
      e.preventDefault();
      if ($(".next-step").length) {
        var step = $('.next-step').data('step');
        Handler.stepHandler(step);
      }
    }
  });

  $(document.body).on('click', '.next-button', function (e) {
    var t = $(this);
    var step = t.data('step');
    Handler.stepHandler(step, t);
    e.preventDefault();
    return false;
  });

  $(document.body).on('click', '.callto', function (e) {
    var telefono = $(this).text();
    if (telefono) {
      LN.AppEvent.sendEvent('CALLTO', telefono);
    }
  });

  $(document.body).on('click', '.mailto', function (e) {
    var mail = $(this).text();
    if (mail) {
      if (Model.MobileEmbed) {
        LN.AppEvent.sendEvent('MAILTO', mail);
        return false;
      } else {
        window.location.href = "mailto:" + mail;
      }
    }
  });


})(LN.App, LN.Router, LN.Controller, LN.Service, LN.Handler, LN.Helper, LN.Config, LN.Model, jQuery, LN.Hotjar);

//ONLOAD
(function (LN) {
  try {
    LN.App.init();
  } catch (err) {
    logger && logger.error('Error: ' + err);
    LN.Service.mostrarError(err);
  }
})(LN);



// WEBPACK FOOTER //
// ./Statics/scripts/paywall/app.js